import Ex1 from './ex1'

export default Object.assign({}, Ex1, {
  showExample: false,
  formData: Object.assign({}, Ex1.formData)
})



/** WEBPACK FOOTER **
 ** ./src/examples/FormationEx1.js
 **/